import React from 'react';

const testimonials = [
  {
    quote: "I had a 320 NEET score and no idea which colleges were realistic. Vaishnavi Educare gave me a shortlist in one day and handled the entire counseling process. Confirmed seat at Rohilkhand Medical College.",
    name: "Priya Sharma",
    program: "MBBS 2023",
    college: "Rohilkhand Medical College, Bareilly",
    initials: "PS",
  },
  {
    quote: "My son scored 285 in NEET and we were worried. The team found us a BAMS seat in Lucknow within two weeks. No hidden charges — exactly as promised. We paid only after the seat was confirmed.",
    name: "Ramesh Kapoor",
    program: "Parent — BAMS 2023",
    college: "SGRR Ayurvedic College, Dehradun",
    initials: "RK",
  },
  {
    quote: "Nepal option was something we hadn't considered. Vaishnavi Educare explained the NMC recognition, the fee structure, everything. My daughter is now at Manipal Academy in Kathmandu.",
    name: "Anita Mehta",
    program: "Parent — MBBS Nepal 2022",
    college: "Manipal Academy of Higher Education, Kathmandu",
    initials: "AM",
  },
];

const Stars = () => (
  <div className="flex gap-0.5 mb-4" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <svg key={i} className="w-4 h-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ))}
  </div>
);

const Testimonials = () => (
  <section className="py-16 md:py-24 bg-white">
    <div className="container mx-auto px-4">

      <div className="text-center max-w-2xl mx-auto mb-12">
        <h2 className="text-section font-bold text-gray-900" style={{ textWrap: 'balance' }}>
          Students Who Trusted Us
        </h2>
        <div className="mt-3 mx-auto w-12 h-0.5 bg-primary-700 rounded-full" />
        <p className="mt-5 text-gray-600 text-lg">
          5,000+ families guided. Here are a few of their stories.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="bg-slate-50 rounded-2xl border border-slate-200 p-7 flex flex-col"
          >
            <Stars />
            <blockquote className="flex-1 text-gray-700 text-sm leading-relaxed mb-6">
              "{t.quote}"
            </blockquote>
            <div className="flex items-center gap-3 pt-5 border-t border-slate-200">
              <div className="w-10 h-10 rounded-full bg-primary-800 text-white text-sm font-semibold flex items-center justify-center shrink-0">
                {t.initials}
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900">{t.name}</p>
                <p className="text-xs text-gray-500 mt-0.5">{t.program} · {t.college}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Graduation photo */}
      <div className="mt-12 rounded-2xl overflow-hidden shadow-sm">
        <img
          src="/photos/graduation.jpg"
          alt="MBBS graduates celebrating"
          className="w-full h-64 md:h-80 object-cover object-center"
        />
      </div>

      {/* Promo flyers — break out of container padding so last card isn't clipped */}
      <div className="mt-10 -mx-4">
        <div className="scrollbar-hide flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3 px-4">
          {[
            { src: '/photos/promo-low-neet.png',    alt: 'Low NEET Score? Your dream is still possible' },
            { src: '/photos/promo-book-mbbs.png',   alt: 'Book Your MBBS Seat — Admissions 2026' },
            { src: '/photos/promo-stress-free.png', alt: 'NEET Score Kam Hai? Stress-Free Ho Jao' },
            { src: '/photos/promo-nepal.png',       alt: 'Study MBBS in Nepal — Kathmandu University' },
            { src: '/photos/promo-bams-delhi.png',  alt: 'BAMS Delhi NCR — Merit/Management/NRI Quota' },
          ].map((img, i) => (
            <div key={i} className="shrink-0 snap-start rounded-2xl overflow-hidden w-56 sm:w-64 aspect-[9/16] shadow-sm border border-slate-100">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="lazy" />
            </div>
          ))}
          {/* trailing spacer keeps last card clear of edge */}
          <div className="shrink-0 w-4" aria-hidden />
        </div>
      </div>

      {/* Samruddhi success story */}
      <div className="mt-6 rounded-2xl overflow-hidden border border-primary-100 bg-primary-50 flex flex-col sm:flex-row items-stretch">
        <div className="sm:w-48 shrink-0">
          <img
            src="/photos/samruddhi.png"
            alt="Samruddhi — NEET Score 168, got admission through Vaishnavi Educare"
            className="w-full h-52 sm:h-full object-cover object-top"
          />
        </div>
        <div className="flex flex-col justify-center px-6 py-5">
          <span className="inline-flex self-start rounded-full bg-primary-800 text-white text-xs font-semibold px-2.5 py-0.5 mb-3">Success Story</span>
          <p className="text-lg font-bold text-gray-900 font-heading leading-snug">Samruddhi</p>
          <p className="text-sm text-primary-800 font-semibold mt-0.5">NEET Score: 168 · Gadchiroli, MH</p>
          <p className="mt-2 text-sm text-gray-600 leading-relaxed">
            Secured BAMS admission in Delhi NCR through Management Quota with Vaishnavi Educare's guidance — confirming that every qualifying score has a path.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Testimonials;
